import { FtueVideo } from '../../api/core'
import { OnboardingVideoCreateBody, OnboardingVideoUpdateBody, ONBOARDING_VIDEO_TYPE } from '../features/onboarding-videos/types/OnboardingVideo'
import { jsonAnswer, optionalJson } from './helpers'
import { internalApiserverApi } from './internal-apiserver'

const onboardingVideosApi = internalApiserverApi.enhanceEndpoints({ addTagTypes: ['internalOnboardingVideos'] }).injectEndpoints({
  endpoints: (builder) => ({
    getOnboardingVideos: builder.query<FtueVideo[], void>({
      query: () => ({ url: 'ftue-videos/', params: { type: ONBOARDING_VIDEO_TYPE } }),
      providesTags: ['internalOnboardingVideos'],
    }),
    getOnboardingVideo: builder.query<FtueVideo | null, string>({
      // A deleted id answers 200 with an empty body.
      query: (id) => ({ url: `ftue-videos/${id}`, responseHandler: optionalJson }),
      providesTags: (_result, _error, id) => [{ type: 'internalOnboardingVideos', id }],
    }),
    createOnboardingVideo: builder.mutation<FtueVideo, OnboardingVideoCreateBody>({
      query: (body) => ({ url: 'i/ftue-videos', method: 'POST', body, headers: jsonAnswer }),
      // Only on success: after a failure the page refetches to check whether the video was stored anyway,
      // and a refetch started by invalidation would answer that with the list from before.
      invalidatesTags: (result) => (result ? ['internalOnboardingVideos'] : []),
    }),
    updateOnboardingVideo: builder.mutation<FtueVideo, OnboardingVideoUpdateBody>({
      query: (body) => ({ url: 'i/ftue-videos', method: 'PUT', body, headers: jsonAnswer }),
      invalidatesTags: (result, _error, body) => (result ? ['internalOnboardingVideos', { type: 'internalOnboardingVideos', id: body.id }] : []),
    }),
    deleteOnboardingVideo: builder.mutation<string, string>({
      query: (id) => ({ url: `i/ftue-videos/${id}`, method: 'DELETE', responseHandler: 'text' }),
      // Not the list: the page refetches it to confirm the delete, and a refetch started by invalidation
      // makes that refetch resolve right away with the list from before the delete.
      invalidatesTags: (_result, _error, id) => [{ type: 'internalOnboardingVideos', id }],
    }),
  }),
})

export const {
  useGetOnboardingVideosQuery,
  useGetOnboardingVideoQuery,
  useCreateOnboardingVideoMutation,
  useUpdateOnboardingVideoMutation,
  useDeleteOnboardingVideoMutation,
} = onboardingVideosApi
